import { FC } from 'react';
import { Divider, Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationParetoSupplier } from '@/libs/fleet-api/services/types';
import { formatCurrency } from '@/libs/antd/formater';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReportUnitForm = {
	lists: OfficeObservationParetoSupplier<'payload'>[];
};

const FBDHVisitReportParetoSupplier: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { warehouse } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportUnitForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>List Supplier Pareto</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: warehouse?.paretoSuppliers ?? [],
					} as VisitReportUnitForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportUnitForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Nama Supplier',
										render: (_, record) => record.supplierName ?? '-',
									},
									{
										title: 'No. Telp Perusahaan',
										render: (_, record) => record.phoneNumber ?? '-',
									},
									{
										title: 'Pembelian/Bulan (Rp)',
										render: (_, record) =>
											formatCurrency(record.monthlyPurchase) ?? '-',
									},
									{
										title: 'Sistem Pembayaran',
										render: (_, record) => record.paymentSystem ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
				<Divider />
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportParetoSupplier;
